module.exports = __webpack_public_path__ + "static/media/ok_clock.1e77dc38.svg";